export const DEFAULT_MFA_RESEND_COOLDOWN_SECONDS = 60;

const positiveWholeSeconds = (value) => (
  typeof value === 'number' && Number.isFinite(value) && value > 0
    ? Math.ceil(value)
    : null
);

export const getMfaResendCooldownSeconds = (
  payload,
  fallbackSeconds = DEFAULT_MFA_RESEND_COOLDOWN_SECONDS,
  nowMs = Date.now()
) => {
  const remaining = positiveWholeSeconds(payload?.cooldown_remaining_seconds);
  if (remaining !== null) return remaining;

  if (typeof payload?.next_resend_available_at === 'string') {
    const availableAtMs = Date.parse(payload.next_resend_available_at);
    if (Number.isFinite(availableAtMs)) {
      return Math.max(0, Math.ceil((availableAtMs - nowMs) / 1000));
    }
  }

  return positiveWholeSeconds(payload?.resend_cooldown_seconds)
    ?? Math.max(0, fallbackSeconds);
};
